import {$controller} from "rapid/index";
import {cloneDeep} from "lodash";

import {DigitalLayoutController} from "./digital-layout/digital-layout";
import DigitalLayoutTemplate from "./digital-layout/digital-layout.html";

import {PrintLayoutController} from "./print-layout/print-layout";
import PrintLayoutTemplate from "./print-layout/print-layout.html";

import {StripLayoutController} from "./strip-layout/strip-layout";
import StripLayoutTemplate from "./strip-layout/strip-layout.html";

import {ChangeNameController} from "./change-name/change-name";
import ChangeNameTemplate from "./change-name/change-name.html";

import {FILE_SIZES} from "../../../constants/file-sizes.constant";
import {COLOR_PICKER_SWATCH_OPTIONS} from "../../../constants/color-picker.constant";

const dependencies = ["$Configuration", "$companies"];

class QuickSetupController extends $controller {

    constructor($injector, $stateParams, $scope, $ToViewValue, $ToBoothValue, $EmailTemplates, $DetectChanges, WizardHandler) {
        "ngInject";
        super($injector, dependencies);
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.wizard = WizardHandler;
        this.isNew = this.$stateParams.isNew;
        this.test = null;
        this.toViewValue = $ToViewValue;
        this.pickerOptions = Object.assign({}, COLOR_PICKER_SWATCH_OPTIONS);
        this.loading = true;
        this.toBoothValue = $ToBoothValue;
        this.emailTemplates = $EmailTemplates;
        this.detectChanges = $DetectChanges;
        this.currentStep = 1;
        this.showBgToggle = false;
        this.wizardOptions = {
          enablePrinting: true,
          enableSharing: true,
          digitalOverlay: null,
          printOverlay: null,
          stripOverlay: null
        };
        this.canLeavePage = false;
        $scope.$on("$stateChangeStart", (event)  => {
            if (!this.canLeavePage) {
                var answer = confirm("You may have unsaved changes in your configuration, if you leave they will be lost!");
                if (!answer) {
                    event.preventDefault();
                }
            }
        });
        window.onbeforeunload = () => {
            if (window.location.href.indexOf("setup") !== -1 && !this.canLeavePage) {
                return "You may have unsaved changes in your configuration, if you leave they will be lost!";
            }
        };
        this.digitalImages = {
            photo: {
                width: 500,
                height: 500,
                x: 0,
                y: 0,
                image: true
            },
            gif: {
                width: 500,
                height: 500,
                x: 0,
                y: 0,
                gif: true
            },
            video: {
                width: 500,
                height: 500,
                x: 0,
                y: 0,
                video: true
            },
        };
        this.printImage = [
            {
                width: 1240,
                height: 1240,
                x: 0,
                y: 72,
                image: true
            }
        ];
        this.stripImages = [
            {
                width: 480,
                height: 480,
                x: 80,
                y: 82,
                rotation: 0,
                title: "1a",
                image: true
            },
            {
                width: 480,
                height: 480,
                x: 80,
                y: 577,
                rotation: 0,
                title: "2a",
                image: true
            },
            {
                width: 480,
                height: 480,
                x: 80,
                y: 1072,
                rotation: 0,
                title: "3a",
                image: true
            },
            {
                width: 480,
                height: 480,
                x: 684,
                y: 82,
                rotation: 0,
                title: "1b",
                image: true
            },
            {
                width: 480,
                height: 480,
                x: 684,
                y: 577,
                rotation: 0,
                title: "2b",
                image: true
            },
            {
                width: 480,
                height: 480,
                x: 684,
                y: 1072,
                rotation: 0,
                title: "3b",
                image: true
            }
        ];
        this.fileSizes = FILE_SIZES;
        let config;
        if ($stateParams.cid && $stateParams.cid !== "create") {
            config = this.$Configuration.get({id: $stateParams.cid});
        } else {
            config = this.$Configuration.get({url: this.$companies.getCached().default_configuration});
        }

        $scope.$on("wizard:stepChanged",(ev) => {
            this.currentStep = ev.targetScope.currentStepNumber();
            //this.saveConfig();
            this.onModeChange();
        });

        config && config.$promise
            .then((config) => {
                this.config = config;
                this.json = config.json;
                this.json.admin.startScreenAreas = this.toViewValue.getStartScreenValues(this.json.admin.startScreenAreas);
                this.setWizardOptions();

                this.deleteUpdatedProperties();
                this.copiedConfig = cloneDeep(this.config);

                if (this.json.client && this.json.client.emailTextNoHtml) {
                    this.json.client.emailTextNoHtml = this.emailTemplates.removeLineBreaks(this.json.client.emailTextNoHtml);
                }
                this.loading = false;
                this.checkBackgroundResolution();
                this.onModeChange();
                let video = document.getElementById("boomerang-video-pr");
                video.src = require("../../../../images/short-preview.mp4");
                video.playbackRate = 2;
            }).catch((e) => {
                console.log(e);
                //this.$state.go("configurations");
            });
    }

    deleteUpdatedProperties() {
        delete this.config.updated;
        delete this.config.json.admin.startScreenAreas.random;

        delete this.config.json.admin.photoBooth.updatePrint;
        delete this.config.json.admin.photoBooth.updateSharing;

        delete this.config.json.admin.gifBooth.updatePrint;
        delete this.config.json.admin.gifBooth.updateSharing;

        delete this.config.json.admin.boomerangBooth.updatePrint;
        delete this.config.json.admin.boomerangBooth.updateSharing;
    }

    openChangeNameDialog(ev) {
        var parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Change configuration name",
            controller: ChangeNameController,
            template: ChangeNameTemplate,
            targetEvent: ev,
            locals: {
                callback: (data) => this.changeName(data),
                name: this.config.name,
                isUpperCase: false
            }
        });
    }

    openDigitalDialog(ev) {
        var parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Set/Share Configuration ID",
            controller: DigitalLayoutController,
            template: DigitalLayoutTemplate,
            targetEvent: ev,
            locals: {
                callback: (data) => this.setDigitalLayouts(data),
                overlay: {attachment_file: this.wizardOptions.digitalOverlay},
                company: this.config.company,
                startScreenDesign: this.json.admin.digitalStartScreenDesign,
                logo: this.json.admin.startScreenLogo.file,
                showLogo: this.json.admin.startScreenLogo.enabled,
                activeMode: this.json.admin.gifBooth.enabled ? "gif" : (this.json.admin.boomerangBooth.enabled ? "boomerang" : "single"),
                background: {
                    file: this.json.admin.startScreenBackground,
                    color: this.json.admin.startScreenBackgroundColor,
                    mode: this.json.admin.startScreenBackgroundMode
                }
            }
        });
    }

    openPrintlDialog(ev) {
        var parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Set/Share Configuration ID",
            controller: PrintLayoutController,
            template: PrintLayoutTemplate,
            targetEvent: ev,
            locals: {
                callback: (data) => this.setPrintLayout(data),
                overlay: {attachment_file: this.wizardOptions.printOverlay},
                company: this.config.company,
                bleed: this.config.json.admin.photoBooth.showPrinterBleeds,
                photos: this.printImage,
                startScreenDesign: this.json.admin.printStartScreenDesign,
                logo: this.json.admin.startScreenLogo.file,
                showLogo: this.json.admin.startScreenLogo.enabled,
                logosArr: this.json.admin.photoBooth.printingLogos,
                background: {
                    file: this.json.admin.startScreenBackground,
                    color: this.json.admin.startScreenBackgroundColor,
                    mode: this.json.admin.startScreenBackgroundMode,
                    logo: this.json.admin.startScreenLogo.file
                }
            }
        });
    }

    openStripDialog(ev) {
        var parentEl = angular.element(document.body);
        this.$mdDialog.show({
            parent: parentEl,
            title: "Set/Share Configuration ID",
            controller: StripLayoutController,
            template: StripLayoutTemplate,
            targetEvent: ev,
            locals: {
                callback: (data) => this.setStripLayout(data),
                overlay: {attachment_file: this.wizardOptions.stripOverlay},
                company: this.config.company,
                bleed: this.config.json.admin.gifBooth.showPrinterBleeds,
                photos: this.stripImages,
                startScreenDesign: this.json.admin.stripStartScreenDesign,
                logo: this.json.admin.startScreenLogo.file,
                showLogo: this.json.admin.startScreenLogo.enabled,
                cuttingLine: this.json.admin.cuttingLine,
                boomerang: !this.json.admin.gifBooth.enabled,
                video: !this.json.admin.videoBooth.enabled,
                logosArr: this.json.admin.gifBooth.printingLogos,
                background: {
                    file: this.json.admin.startScreenBackground,
                    color: this.json.admin.startScreenBackgroundColor,
                    mode: this.json.admin.startScreenBackgroundMode
                }
            }
        });
    }

    selectMode(mode) {
        this.json.admin[mode].enabled = !this.json.admin[mode].enabled;

        let photo = this.json.admin.photoBooth.enabled;
        let gif = this.json.admin.gifBooth.enabled;
        let boomerang = this.json.admin.boomerangBooth.enabled;
        let video = this.json.admin.videoBooth.enabled;
        let isTop = this.json.admin.startScreenLogo.position <= 4;


        this.json.admin.startScreenAreas.single = {width: 40, height: 40, x: 25, y: (isTop ? 60 : 40)};
        this.json.admin.startScreenAreas.gif = {width: 40, height: 40, x: 50, y: (isTop ? 60 : 40)};
        this.json.admin.startScreenAreas.boomerang = {width: 40, height: 40, x: 75, y: (isTop ? 60 : 40)};
        this.json.admin.startScreenAreas.video = {width: 40, height: 40, x: 95, y: (isTop ? 60 : 40)};

        if (photo && gif && !boomerang && !video) {
            this.json.admin.startScreenAreas.single.x = 37.5;
            this.json.admin.startScreenAreas.gif.x = 62.5;
            this.json.admin.startScreenAreas.boomerang = {};
            this.json.admin.startScreenAreas.video = {};
        } else if (photo && !gif && boomerang && !video) {
            this.json.admin.startScreenAreas.single.x = 37.5;
            this.json.admin.startScreenAreas.gif = 0;
            this.json.admin.startScreenAreas.boomerang.x = 62.5;
            this.json.admin.startScreenAreas.video = {};
        } else if (!photo && gif && boomerang && !video) {
            this.json.admin.startScreenAreas.single = {};
            this.json.admin.startScreenAreas.gif.x = 37.5;
            this.json.admin.startScreenAreas.boomerang.x = 62.5;
            this.json.admin.startScreenAreas.video = {};
        } else if (!photo && !gif && boomerang && video) {
            this.json.admin.startScreenAreas.single = {};
            this.json.admin.startScreenAreas.gif = {};
            this.json.admin.startScreenAreas.boomerang.x = 50;
            this.json.admin.startScreenAreas.video = {};
        } else if (!photo && gif && !boomerang && !video) {
            this.json.admin.startScreenAreas.single = {};
            this.json.admin.startScreenAreas.gif.x = 50;
            this.json.admin.startScreenAreas.boomerang = {};
            this.json.admin.startScreenAreas.video = {};
        } else if (photo && !gif && !boomerang && !video) {
            this.json.admin.startScreenAreas.single.x = 50;
            this.json.admin.startScreenAreas.gif = {};
            this.json.admin.startScreenAreas.boomerang = {};
            this.json.admin.startScreenAreas.video = {};
        } else if (photo && !gif && !boomerang && video) {
            this.json.admin.startScreenAreas.single.x = 50;
            this.json.admin.startScreenAreas.gif = {};
            this.json.admin.startScreenAreas.boomerang = {};
            this.json.admin.startScreenAreas.video = 37.5;
        } else if (photo && gif && !boomerang && video) {
            this.json.admin.startScreenAreas.single.x = 37.5;
            this.json.admin.startScreenAreas.gif = 62.5;
            this.json.admin.startScreenAreas.boomerang = {};
            this.json.admin.startScreenAreas.video = 95;
        } else if (!photo && !gif && !boomerang && video) {
            this.json.admin.startScreenAreas.single.x = {};
            this.json.admin.startScreenAreas.gif = {};
            this.json.admin.startScreenAreas.boomerang = {};
            this.json.admin.startScreenAreas.video = 95;
        }

        this.checkModes(mode);
    }

    setDigitalLayouts(data) {
        if (data.overlay && data.overlay.attachment_file) {
            this.wizardOptions.digitalOverlay = data.overlay.attachment_file;
            this.json.admin.photoBooth.sharingOverlayFiles = [data.overlay.attachment_file];
            this.json.admin.gifBooth.sharingOverlayFiles = [data.overlay.attachment_file];
            this.json.admin.boomerangBooth.sharingOverlayFiles = [data.overlay.attachment_file];
        } else {
            this.wizardOptions.digitalOverlay = null;
            this.json.admin.photoBooth.sharingOverlayFiles = [];
            this.json.admin.gifBooth.sharingOverlayFiles = [];
            this.json.admin.boomerangBooth.sharingOverlayFiles = [];
        }
        this.json.admin.digitalStartScreenDesign = data.startScreenDesign;

        this.setDigitalBackground();
    }

    setDigitalBackground() {
        if (!this.json) return;

        if (this.json.admin.digitalStartScreenDesign) {
            this.json.admin.gifBooth.sharingBackgroundColor = this.json.admin.startScreenBackgroundColor;
            this.json.admin.gifBooth.sharingBackgroundMode = this.json.admin.startScreenBackgroundMode;
            this.json.admin.gifBooth.startScreenDesignSharing = true;

            if (this.json.admin.gifBooth.sharingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
                this.json.admin.gifBooth.sharingBackgroundFiles = [(this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file)];
            }

            this.json.admin.photoBooth.sharingBackgroundColor = this.json.admin.startScreenBackgroundColor;
            this.json.admin.photoBooth.sharingBackgroundMode = this.json.admin.startScreenBackgroundMode;
            this.json.admin.photoBooth.startScreenDesignSharing = true;

            if (this.json.admin.photoBooth.sharingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
                this.json.admin.photoBooth.sharingBackgroundFiles = [(this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file)];
            }

            this.json.admin.boomerangBooth.sharingBackgroundColor = this.json.admin.startScreenBackgroundColor;
            this.json.admin.boomerangBooth.sharingBackgroundMode = this.json.admin.startScreenBackgroundMode;
            this.json.admin.boomerangBooth.startScreenDesignSharing = true;

            if (this.json.admin.boomerangBooth.sharingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
                this.json.admin.boomerangBooth.sharingBackgroundFiles = [(this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file)];
            }
        } else {
            this.json.admin.gifBooth.sharingBackgroundFiles = [];
            this.json.admin.gifBooth.backgroundColor = "#ffffff";
            this.json.admin.gifBooth.backgroundMode = this.json.admin.startScreenBackgroundMode;
            this.json.admin.gifBooth.startScreenDesignSharing = false;

            this.json.admin.photoBooth.sharingBackgroundFiles = [];
            this.json.admin.photoBooth.backgroundColor = "#ffffff";
            this.json.admin.photoBooth.backgroundMode = this.json.admin.startScreenBackgroundMode;
            this.json.admin.photoBooth.startScreenDesignSharing = false;

            this.json.admin.boomerangBooth.sharingBackgroundFiles = [];
            this.json.admin.boomerangBooth.backgroundColor = "#ffffff";
            this.json.admin.boomerangBooth.backgroundMode = this.json.admin.startScreenBackgroundMode;
            this.json.admin.boomerangBooth.startScreenDesignSharing = false;
        }
    }

    setPrintLayout(data) {
        if (!this.json) return;

        if (data.overlay && data.overlay.attachment_file) {
            this.wizardOptions.printOverlay = data.overlay.attachment_file;
            this.json.admin.photoBooth.printingOverlayFiles = [data.overlay.attachment_file];
        } else {
            this.wizardOptions.printOverlay = null;
            this.json.admin.photoBooth.printingOverlayFiles = [];
        }
        this.json.admin.photoBooth.showPrinterBleeds = data.bleed;
        this.json.admin.printStartScreenDesign = data.startScreenDesign;

        this.setPrintBackground();
    }

    setPrintBackground() {
        if (!this.json) return;

        if (this.json.admin.printStartScreenDesign) {
            this.json.admin.photoBooth.printingBackgroundColor = this.json.admin.startScreenBackgroundColor;
            this.json.admin.photoBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;

            if (this.json.admin.photoBooth.printingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
                this.json.admin.photoBooth.printingBackgroundFiles = [(this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file)];
            }
        } else {
            this.json.admin.photoBooth.printingBackgroundFiles = [];
            this.json.admin.photoBooth.printingBackgroundColor = "#ffffff";
            this.json.admin.photoBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;
        }
    }

    setStripLayout(data) {
        if (!this.json) return;

        if (data.overlay && data.overlay.attachment_file) {
            this.wizardOptions.stripOverlay = data.overlay.attachment_file;
            this.json.admin.gifBooth.printingOverlayFiles = [data.overlay.attachment_file];
            this.json.admin.boomerangBooth.printingOverlayFiles = [data.overlay.attachment_file];
        } else {
            this.wizardOptions.stripOverlay = null;
            this.json.admin.gifBooth.printingOverlayFiles = [];
            this.json.admin.boomerangBooth.printingOverlayFiles = [];
        }
        this.json.admin.gifBooth.showPrinterBleeds = data.bleed;
        this.json.admin.gifBooth.showPrinterBleeds = data.bleed;
        this.json.admin.stripStartScreenDesign = data.startScreenDesign;
        this.json.admin.cuttingLine = data.cuttingLine;

        this.setStripBackground();
    }

    setStripBackground() {
        if (!this.json) return;

        if (this.json.admin.stripStartScreenDesign) {
            this.json.admin.gifBooth.printingBackgroundColor = this.json.admin.startScreenBackgroundColor;
            this.json.admin.gifBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;

            if (this.json.admin.gifBooth.printingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
                this.json.admin.gifBooth.printingBackgroundFiles = [(this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file)];
            }

            this.json.admin.boomerangBooth.printingBackgroundColor = this.json.admin.startScreenBackgroundColor;
            this.json.admin.boomerangBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;

            if (this.json.admin.boomerangBooth.printingBackgroundMode === "image" && this.json.admin.startScreenBackground) {
                this.json.admin.boomerangBooth.printingBackgroundFiles = [(this.json.admin.startScreenBackground.first_frame || this.json.admin.startScreenBackground.attachment_file)];
            }

        } else {
            this.json.admin.gifBooth.printingBackgroundFiles = [];
            this.json.admin.gifBooth.printingBackgroundColor = "#ffffff";
            this.json.admin.gifBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;

            this.json.admin.boomerangBooth.printingBackgroundFiles = [];
            this.json.admin.boomerangBooth.printingBackgroundColor = "#ffffff";
            this.json.admin.boomerangBooth.printingBackgroundMode = this.json.admin.startScreenBackgroundMode;
        }
    }

    changeName(title) {
        this.config.name = title;
        this.saveConfig();
    }

    saveConfig(action) {
        if (!this.canExitSharingScreen()) {
            return false;
        }
        if (action) {
            this.canLeavePage = true;
        }
        if (action === "advanced") {
            this.config.json.admin.isAdvanced = true;
        }
        if (this.config.json.client.emailTextNoHtml) {
            this.config.json.client.emailTextNoHtml = this.emailTemplates.addLineBreaks(this.config.json.client.emailTextNoHtml);
        }
        this.createTemplateFromDefault();
        let configToSave = cloneDeep(this.config);
        configToSave.json.admin.startScreenAreas = this.toBoothValue.transformStartScreenAreas(configToSave.json.admin.startScreenAreas);
        configToSave.json.admin.startScreenLogo.boothStyle = this.toBoothValue.setLogoStyle(configToSave.json.admin.startScreenLogo);

        configToSave.json.admin.photoBooth.updatePrint =
            this.detectChanges.checkBoothPrintChange(configToSave.json.admin.photoBooth, this.copiedConfig.json.admin.photoBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
        configToSave.json.admin.photoBooth.updateSharing =
            this.detectChanges.checkBoothSharingChange(configToSave.json.admin.photoBooth, this.copiedConfig.json.admin.photoBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);

        configToSave.json.admin.gifBooth.updatePrint =
            this.detectChanges.checkBoothPrintChange(configToSave.json.admin.gifBooth, this.copiedConfig.json.admin.gifBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
        configToSave.json.admin.gifBooth.updateSharing =
            this.detectChanges.checkBoothSharingChange(configToSave.json.admin.gifBooth, this.copiedConfig.json.admin.gifBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);

        configToSave.json.admin.boomerangBooth.updatePrint =
            this.detectChanges.checkBoothPrintChange(configToSave.json.admin.boomerangBooth, this.copiedConfig.json.admin.boomerangBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
        configToSave.json.admin.boomerangBooth.updateSharing =
            this.detectChanges.checkBoothSharingChange(configToSave.json.admin.boomerangBooth, this.copiedConfig.json.admin.boomerangBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);

        configToSave.json.admin.videoBooth.updateSharing =
            this.detectChanges.checkBoothSharingChange(configToSave.json.admin.videoBooth, this.copiedConfig.json.admin.videoBooth, configToSave.json.admin.startScreenLogo.file, this.copiedConfig.json.admin.startScreenLogo.file);
        this.$Configuration.update(configToSave)
            .$promise
            .then((r) => {
                let toast = this.$mdToast.simple()
                    .textContent(this.gettext("Configuration saved!"))
                    .highlightAction(true)
                    .highlightClass("md-accent")
                    .position("bottom right");
                this.$mdToast.show(toast);
                if (action === "advanced") {
                    this.$state.go("configurations.update", {cid: this.$filter("getObjectId")(r.url)});
                } else if (action === "draft") {
                    this.$state.go("configurations");
                }
            }).catch((error) => {
            this.showErrorDialog("Error", `<p>${error.data && error.data.error ? error.data.error : "Some error occured"}</p>`);
            this.$state.go("configurations");
        });
    }

    setWizardOptions() {
        this.wizardOptions.digitalOverlay = this.json.admin.photoBooth.sharingOverlayFiles ? this.json.admin.photoBooth.sharingOverlayFiles[0] : null;
        this.wizardOptions.printOverlay = this.json.admin.photoBooth.printingOverlayFiles ? this.json.admin.photoBooth.printingOverlayFiles[0] : null;
        this.wizardOptions.stripOverlay = this.json.admin.gifBooth.printingOverlayFiles ? this.json.admin.gifBooth.printingOverlayFiles[0] : null;
        this.wizardOptions.enablePrinting =  this.json.admin.photoBooth.allowPrinting;
        this.wizardOptions.enableSharing = this.json.admin.photoBooth.allowSharing;
    }

    // Screen validation
    canExitModeScreen() {
        if (!this.json || !this.json.admin) return false;

        let modes = this.json.admin;
        // if no mode was selected
        if (!modes.gifBooth.enabled && !modes.photoBooth.enabled && !modes.boomerangBooth.enabled && !modes.videoBooth.enabled) {
            return false;
        }
        return true;
    }

    canExitDesignScreen() {
        if (!this.json || !this.json.admin) return false;

        return true;
    }

    canExitSharingScreen() {
        if (!this.json || !this.json.admin || !this.json.client) return false;

        if (this.json.admin.outputSettings.enableSmsSharing && !this.json.client.smsText) {
            this.showErrorDialog("Error", `<p>Please, provide SMS sharing text</p>`);
            return false;
        }

        if (this.json.admin.outputSettings.enableSmsSharing && (
            !this.json.client.emailSubject || !this.json.client.emailTitle || !this.json.client.emailTextNoHtml
        )) {
            this.showErrorDialog("Error", `<p>Please, provide all email sharing information</p>`);
            return false;
        }


        return true;
    }

    changeSharing() {
        this.json.admin.photoBooth.allowSharing = this.wizardOptions.enableSharing;
        this.json.admin.gifBooth.allowSharing = this.wizardOptions.enableSharing;
        this.json.admin.boomerangBooth.allowSharing = this.wizardOptions.enableSharing;
        this.json.admin.videoBooth.allowSharing = this.wizardOptions.enableSharing;
    }

    changePrinting() {
        this.json.admin.photoBooth.allowPrinting = this.wizardOptions.enablePrinting;
        this.json.admin.gifBooth.allowPrinting = this.wizardOptions.enablePrinting;
        this.json.admin.boomerangBooth.allowPrinting = this.wizardOptions.enablePrinting;
        this.json.admin.videoBooth.allowPrinting = this.wizardOptions.enablePrinting;
    }

    changeAreas() {
        if (this.json.admin.startScreenLogo.position <= 3) {
            this.json.admin.startScreenAreas.single.y ? this.json.admin.startScreenAreas.single.y = 60 : null;
            this.json.admin.startScreenAreas.gif.y ? this.json.admin.startScreenAreas.gif.y = 60 : null;
            this.json.admin.startScreenAreas.boomerang.y ? this.json.admin.startScreenAreas.boomerang.y = 60 : null;
            this.json.admin.startScreenAreas.video.y ? this.json.admin.startScreenAreas.video.y = 60 : null;
        } else {
            this.json.admin.startScreenAreas.single.y ? this.json.admin.startScreenAreas.single.y = 40 : null;
            this.json.admin.startScreenAreas.gif.y ? this.json.admin.startScreenAreas.gif.y = 40 : null;
            this.json.admin.startScreenAreas.boomerang.y ? this.json.admin.startScreenAreas.boomerang.y = 40 : null;
            this.json.admin.startScreenAreas.video.y ? this.json.admin.startScreenAreas.video.y = 40 : null;
        }
    }

    createTemplateFromDefault() {
        let template = null;
        switch (this.json.client.emailTemplate) {
            case "German informal":
                template = "germanInformal";
                break;
            case "German formal":
                template = "germanFormal";
                break;
            case "English":
                template = "english";
                break;
        }
        if (template) {
            this.config.json.client.emailText = this.emailTemplates.getTemplate(template, this.config.json.client.emailTitle, this.config.json.client.emailTextNoHtml);
        }
    }

    onTemplateChange() {
        switch (this.json.client.emailTemplate) {
            case "German informal":
                this.json.client.emailSubject = "Dein UpReach Foto";
                this.json.client.emailTitle = "Hey, super Foto!";
                this.json.client.emailTextNoHtml = "Bitte schön, dein tolles UpReach-Foto findest du im Anhang 🎉 Vielen Dank für deinen Besuch! 🙏\n" +
                    "Scrolle ans Ende der E-Mail, um das Foto herunterzuladen & zu teilen.";
                this.json.client.smsText = "Hey, super Foto! 🎉\n" +
                    "Besuche die Live-Galerie, um dein UpReach-Foto herunterzuladen & zu teilen: ";
                return;
            case "German formal":
                this.json.client.emailSubject = "Ihr UpReach Foto";
                this.json.client.emailTitle = "Hey, super Foto!";
                this.json.client.emailTextNoHtml = "Bitte sehr, Ihr tolles UpReach-Foto finden Sie im Anhang 🎉 Vielen Dank für Ihren Besuch! 🙏\n" +
                    "Scrollen Sie ans Ende der E-Mail, um das Foto herunterzuladen & zu teilen.";
                this.json.client.smsText = "Hey, super Foto! 🎉\n" +
                    "Besuchen Sie die Live-Galerie, um Ihr UpReach-Foto herunterzuladen & zu teilen: ";
                return;
            case "English":
                this.json.client.emailSubject = "Your UpReach photo";
                this.json.client.emailTitle = "Hey, nice snap!";
                this.json.client.emailTextNoHtml = "Here you are, please find attached your awesome UpReach photo. Thank you so much for visiting us!\n Scroll down to download & share your image.";
                this.json.client.smsText = "Hey, nice snap!\nVisit the live gallery to download & share your UpReach photo: ";
                return;
        }
    }

    onModeChange() {
        this.setDigitalBackground();
        this.setPrintBackground();
        this.setStripBackground();
    }

    resetEmail() {
        this.json.client.emailTemplate = "English";
        this.json.client.emailSubject = "Your UpReach photo";
        this.json.client.emailTitle = "Hey, nice snap!";
        this.json.client.emailTextNoHtml = "Here you are, please find attached your awesome UpReach photo. Thank you so much for visiting us!\n Scroll down to download & share your image.";
    }

    resetSMS() {
        this.json.client.smsText = "Hey, nice snap!\n Visit the live gallery to download & share your UpReach photo: ";
    }

    nextStep() {
        this.wizard.wizard().next();
    }

    checkBackgroundResolution() {
        setTimeout(() => {
            if (this.json.admin && this.json.admin.startScreenBackground && this.json.admin.startScreenBackground.attachment_file) {
                let isVideo = this.json.admin.startScreenBackground.attachment_file.indexOf(".mp4") !== -1;
                const VALID_RESOLUTION = 1920/1080;
                let media = isVideo ? new Video() : new Image();
                media.src = this.json.admin.startScreenBackground.attachment_file;
                if (isVideo) {
                    media.onloadeddata = () => {
                        if (media.videoWidth/media.videoHeight !== VALID_RESOLUTION) {
                            this.showBgToggle = true;
                        } else {
                            this.showBgToggle = false;
                        }
                    };
                } else {
                    media.onload = () => {
                        if (media.width/media.height !== VALID_RESOLUTION) {
                            this.showBgToggle = true;
                        } else {
                            this.showBgToggle = false;
                        }
                    };
                }
            } else {
                this.showBgToggle = false;
            }
        });

        function Video() {
            return document.createElement("video");
        }
    }

    checkModes(booth) {
        if (booth === "photoBooth") {
            if (!this.json.admin.gifBooth.enabled && !this.json.admin.boomerangBooth.enabled && !this.json.admin.videoBooth.enabled) {
                this.json.admin.photoBooth.enabled = true;
            }
        }

        if (booth === "gifBooth") {
            if (!this.json.admin.photoBooth.enabled && !this.json.admin.boomerangBooth.enabled && !this.json.admin.videoBooth.enabled) {
                this.json.admin.gifBooth.enabled = true;
            }
        }

        if (booth === "boomerangBooth") {
            if (!this.json.admin.gifBooth.enabled && !this.json.admin.photoBooth.enabled && !this.json.admin.videoBooth.enabled) {
                this.json.admin.boomerangBooth.enabled = true;
            }
        }

        if (booth === "videoBooth") {
            if (!this.json.admin.gifBooth.enabled && !this.json.admin.photoBooth.enabled && !this.json.admin.boomerangBooth.enabled) {
                this.json.admin.videoBooth.enabled = true;
            }
        }

    }
    showErrorDialog(title, HTMLtext) {
        this.$mdDialog.show(
            this.$mdDialog.alert()
                .clickOutsideToClose(true)
                .title(this.gettext(title))
                .htmlContent(this.gettext(HTMLtext))
                .ariaLabel(this.gettext("Error"))
                .ok("OK")
                .targetEvent(event)
        );
    }
    getFileType(file) {
        if (!file) {
            return true;
        }

        if (!file.attachment_file) {
            return true;
        }

        if (typeof file.attachment_file !== "string") {
            return true;
        }

        let str = file.attachment_file.split(".");

        return str[str.length -1];
    }
}

export default QuickSetupController;



// WEBPACK FOOTER //
// ./sources/components/configurations/quick-setup/quick-setup.controller.js